import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextIndicator: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-indicator"><path d="M2.75 5.75H8M8 5.75H13.25M8 5.75V18.25M16.75 2.75H19M19 2.75H21.25M19 2.75V21.25M19 21.25H16.75M19 21.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTextIndicator;
